export default __webpack_public_path__ + "static/media/Long Blue.0ff2b78d.png";